import { render } from "./Dashboard.vue?vue&type=template&id=700f3650&scoped=true"
const script = {}

import "./Dashboard.vue?vue&type=style&index=0&id=700f3650&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700f3650"]])

export default __exports__